export const isDutchiePlusKioskOrder = (orderType: string, isPlusVariant: boolean): boolean =>
  orderType === 'kiosk' && isPlusVariant;
